export default __webpack_public_path__ + "static/media/logo-com-intech.6298418c.png";